import { getAPI } from "@/axios-api";
export async function fetchUserData() {
    try {
      const response = await getAPI.get('accounts/users/me');
      
      if (response.status === 200) {
        return {
          data: response.data?.data,
        };
      }
      return { data: null };
    } catch (error) {
      if (error.response) {
        console.error('API Error:', error.response.data);
      } else if (error.request) {
        console.error('Network Error:', error.request);
      }
      return { error: true };
    }
  }